import React from 'react';
import { LanguagesEnum } from 'constants/languages';
import * as LanguageSelectors from 'redux/reducers/gl_translations_reducer/selectors';
import EnglishTranslations from 'assets/translations/en_translations.json';
import GreekTranslations from 'assets/translations/gr_translations.json';
import GermanTranslations from 'assets/translations/de_translations.json';
import ItalianTranslations from 'assets/translations/it_translations.json';
import _ from 'lodash';

const TranslationsMap = {
  [LanguagesEnum.English]: EnglishTranslations,
  [LanguagesEnum.Greek]: GreekTranslations,
  [LanguagesEnum.German]: GermanTranslations,
  [LanguagesEnum.Italian]: ItalianTranslations,
};

interface IProps {
  translationKey: string;
  defaultText?: string;
}

const TranslatedText = ({
  translationKey,
  defaultText = '',
}: IProps): React.ReactElement => {
  const languageID: LanguagesEnum = LanguageSelectors.useSelectLanguageID();

  return (
    <React.Fragment>
      {_.get(
        TranslationsMap[languageID],
        `${translationKey}`,
        defaultText || 'Translation Not Found'
      )}
    </React.Fragment>
  );
};

export default TranslatedText;
